import { useMedia } from "react-use";

export const useMediaMaxWidth = (size: number | string) => {
  const SCREEN_BREAKPOINTS = typeof size === "number" ? size + "px" : size;
  return useMedia(`(max-width: ${SCREEN_BREAKPOINTS})`);
};
